export const PDP_TEMPLATES = {
  WORKSPACE: 'workspace'
};

export const HIDDEN_CLASS = 'hidden';

export const STICKY_BAR_SELECTORS = {
  triggerPreventScrollingElement: '.breadcrumbs-wrapper'
};

export const API_NAMES = {
  IQS: 'Inventory Query (IQS)',
  PS: 'Product Service'
};
